<template>
	<div class="dashboard-container">
		<!-- 统计卡片 -->
		<el-row :gutter="24">
			<el-col :span="6" v-for="(item, index) in statCards" :key="index">
				<div class="stat-card">
					<div class="card-icon" :style="{ color: item.color }">
						<i :class="item.icon"></i>
					</div>
					<div class="card-content">
						<p class="card-title">{{ item.name }}</p>
						<count-to
							class="card-num"
							:startVal="0"
							:endVal="item.value"
							:duration="600"
						></count-to>
					</div>
					<div class="card-footer">
						<span class="growth-text" :class="{ 'is-up': item.isUp, 'is-down': !item.isUp }">
							<i :class="item.isUp ? 'el-icon-top' : 'el-icon-bottom'"></i>
							{{ item.growth }}
						</span>
						<span class="period-text">较上月</span>
					</div>
				</div>
			</el-col>
		</el-row>

		<!-- 我的报告 -->
		<div class="section-wrapper">
			<div class="section-header">
				<h3 class="section-title">我的报告</h3>
				<div class="section-actions">
					<el-button
						type="primary"
						icon="el-icon-plus"
						class="create-report-btn"
						@click="goToCreateReport"
					>
						创建新报告
					</el-button>
					<el-link type="primary" class="view-all-link">查看全部</el-link>
				</div>
			</div>

			<el-row :gutter="20">
				<el-col :span="8" v-for="(report, index) in myReports" :key="index">
					<div class="report-card" :class="report.statusClass">
						<div class="report-header">
							<h4 class="report-title">{{ report.title }}</h4>
							<el-tag size="small" :type="report.tagType">{{ report.status }}</el-tag>
						</div>
						<p class="report-desc">{{ report.description }}</p>
						<div class="report-footer">
							<div class="report-date"><i class="el-icon-date"></i> {{ report.date }}</div>
							<div class="report-actions">
								<el-button
									v-for="(action, i) in report.actions"
									:key="i"
									:icon="action.icon"
									circle
									plain
									size="mini"
								></el-button>
							</div>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>

		<!-- 图表和最近活动 -->
		<el-row :gutter="20">
			<!-- 图表 -->
			<el-col :span="16">
				<div class="chart-container">
					<div class="chart-header">
						<h3 class="chart-title">报告趋势</h3>
						<div class="chart-controls">
							<el-radio-group v-model="chartPeriod" size="small">
								<el-radio-button label="monthly">月度</el-radio-button>
								<el-radio-button label="quarterly">季度</el-radio-button>
								<el-radio-button label="yearly">年度</el-radio-button>
							</el-radio-group>
						</div>
					</div>
					<div class="chart-wrapper">
						<canvas ref="reportTrendChart" width="800" height="400"></canvas>
						<div class="chart-legend">
							<div class="legend-item">
								<span class="legend-dot completed"></span>
								<span class="legend-text">已完成报告</span>
							</div>
							<div class="legend-item">
								<span class="legend-dot in-progress"></span>
								<span class="legend-text">进行中报告</span>
							</div>
						</div>
					</div>
				</div>
			</el-col>

			<!-- 最近活动 -->
			<el-col :span="8">
				<div class="activity-container">
					<div class="activity-header">
						<h3 class="activity-title">最近活动</h3>
						<el-link type="primary" class="view-all-link">查看全部</el-link>
					</div>
					<div class="activity-list">
						<div class="activity-item" v-for="(activity, index) in recentActivities" :key="index">
							<div class="activity-icon" :style="{ background: activity.iconBg }">
								<i :class="activity.icon"></i>
							</div>
							<div class="activity-content">
								<p class="activity-text" v-html="activity.text"></p>
								<p class="activity-time">{{ activity.time }}</p>
							</div>
						</div>
					</div>
				</div>
			</el-col>
		</el-row>

		<!-- 悬浮创建报告按钮 -->
		<div class="create-report-fab" data-text="创建新报告" @click="goToCreateReport">
			<i class="el-icon-plus"></i>
		</div>
	</div>
</template>

<script>
// import { supabaseAdmin } from '@/utils/supabase';

// 使用一个简单的过渡组件代替CountTo库
const CountTo = {
	props: {
		startVal: {
			type: Number,
			default: 0,
		},
		endVal: {
			type: Number,
			required: true,
		},
		duration: {
			type: Number,
			default: 2000,
		},
	},
	data() {
		return {
			displayValue: 0,
			instruments: [],
		};
	},
	mounted() {
		this.animateValue();
		// this.getInstruments();
	},
	methods: {
		// async getInstruments() {
		// 	const { data } = await supabaseAdmin.from('jiang').select('*');
		// 	this.instruments = data;
		// },
		animateValue() {
			const startTime = new Date();
			const updateInterval = 50; // 更新频率

			const timer = setInterval(() => {
				const now = new Date();
				const progress = Math.min(1, (now - startTime) / this.duration);

				if (progress === 1) {
					this.displayValue = this.endVal;
					clearInterval(timer);
				} else {
					this.displayValue = Math.floor(this.startVal + progress * (this.endVal - this.startVal));
				}
			}, updateInterval);
		},
	},
	render(h) {
		return h('span', this.displayValue.toLocaleString());
	},
};

export default {
	name: 'DashboardPage',
	components: {
		CountTo,
	},
	data() {
		return {
			loading: false,
			chartPeriod: 'monthly',
			chartInstance: null,
			statCards: [
				{
					name: '总报告数',
					value: 128,
					icon: 'el-icon-document',
					color: '#409EFF',
					growth: '12%',
					isUp: true,
				},
				{
					name: '本月新增报告',
					value: 32,
					icon: 'el-icon-plus',
					color: '#409EFF',
					growth: '3%',
					isUp: false,
				},
				{
					name: '报告模板',
					value: 3,
					icon: 'el-icon-collection',
					color: '#409EFF',
					growth: '5%',
					isUp: true,
				},
				{
					name: '模板总版本',
					value: 11,
					icon: 'el-icon-time',
					color: '#409EFF',
					growth: '10%',
					isUp: false,
				},
			],
			myReports: [
				{
					title: 'apnimed公司CP109调研报告',
					status: '进行中',
					statusClass: 'draft',
					tagType: 'warning',
					description: '该报告是apnimed公司CP109项目调研报告，包含学术、市场、专利等多维度分析。',
					date: '更新于 2023-06-15',
					actions: [{ icon: 'el-icon-edit' }, { icon: 'el-icon-view' }],
				},
				{
					title: '南方医科大南方医院调研报告',
					status: '已完成',
					statusClass: 'completed',
					tagType: 'success',
					description:
						'华南地区最大肿瘤专科医院，包含医院、科室、医生、患者、设备、临床试验等多维度分析。',
					date: '完成于 2023-06-10',
					actions: [{ icon: 'el-icon-download' }, { icon: 'el-icon-view' }],
				},
			],
			chartData: {
				monthly: {
					labels: [
						'1月',
						'2月',
						'3月',
						'4月',
						'5月',
						'6月',
						'7月',
						'8月',
						'9月',
						'10月',
						'11月',
						'12月',
					],
					completed: [12, 15, 18, 14, 20, 25, 22, 28, 30, 32, 35, 38],
					inProgress: [8, 10, 12, 15, 13, 18, 16, 20, 18, 22, 20, 24],
				},
				quarterly: {
					labels: ['Q1 2022', 'Q2 2022', 'Q3 2022', 'Q4 2022', 'Q1 2023', 'Q2 2023'],
					completed: [45, 60, 80, 95, 105, 120],
					inProgress: [30, 40, 55, 60, 65, 75],
				},
				yearly: {
					labels: ['2018', '2019', '2020', '2021', '2022', '2023'],
					completed: [180, 240, 320, 380, 450, 520],
					inProgress: [120, 160, 210, 250, 280, 320],
				},
			},
			recentActivities: [
				{
					icon: 'el-icon-plus',
					iconBg: '#E6F7FF',
					text: '创建了新报告 <span class="highlight-text">抗肿瘤药物XYZ-123临床前研究</span>',
					time: '今天 09:41',
				},
				{
					icon: 'el-icon-edit',
					iconBg: '#F6FFED',
					text: '更新了报告 <span class="highlight-text">心血管药物ABC-456安全性评估</span>',
					time: '昨天 16:23',
				},
				{
					icon: 'el-icon-collection',
					iconBg: '#F9F0FF',
					text: '创建了新模板 <span class="highlight-text">抗生素药效学评估标准模板</span>',
					time: '2天前 11:30',
				},
				{
					icon: 'el-icon-share',
					iconBg: '#FFF7E6',
					text: '分享了报告 <span class="highlight-text">神经系统药物DEF-789临床I期总结</span>',
					time: '3天前 14:15',
				},
			],
		};
	},
	mounted() {
		// this.initChart();
		window.addEventListener('resize', this.resizeChart);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.resizeChart);
	},
	watch: {
		chartPeriod() {
			this.updateChart();
		},
	},
	methods: {
		// 初始化图表

		// 保留原有的方法
		statusTag(status) {
			const map = {
				进行中: 'warning',
				待处理: 'info',
				已完成: 'success',
				已取消: 'danger',
			};
			return map[status] || '';
		},
		priorityTag(priority) {
			const map = {
				高: 'danger',
				中: 'warning',
				低: 'info',
			};
			return map[priority] || '';
		},
		// 添加跳转创建报告页面的方法
		goToCreateReport() {
			this.$router.push('/createreport');
		},
	},
};
</script>

<style scoped>
.dashboard-container {
	padding: 24px;
	position: relative;
	background-color: #f8fafc;
	min-height: calc(100vh - 60px);
}

/* 统计卡片样式 */
.stat-card {
	background-color: white;
	border-radius: 16px;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
	padding: 24px;
	margin-bottom: 24px;
	transition: all 0.3s ease;
	border: 1px solid #f1f5f9;
	position: relative;
	overflow: hidden;
}

.card-icon {
	position: absolute;
	top: 20px;
	right: 20px;
	width: 40px;
	height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 10px;
	background-color: #f0f7ff;
	transition: all 0.3s ease;
}

.card-icon i {
	font-size: 20px;
}

.stat-card:hover {
	transform: translateY(-4px);
	box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);
}

.stat-card:hover .card-icon {
	transform: scale(1.1);
}

.card-content {
	padding-right: 50px;
}

.card-title {
	font-size: 15px;
	color: #64748b;
	margin: 0;
	margin-bottom: 8px;
	font-weight: 500;
}

.card-num {
	font-size: 28px;
	font-weight: 600;
	color: #0f172a;
	line-height: 1.2;
	margin-bottom: 16px;
}

.card-footer {
	display: flex;
	align-items: center;
	margin-top: auto;
}

.growth-text {
	display: flex;
	align-items: center;
	font-size: 14px;
	font-weight: 500;
	margin-right: 8px;
}

.growth-text.is-up {
	color: #67c23a;
}

.growth-text.is-down {
	color: #f56c6c;
}

.growth-text i {
	margin-right: 4px;
}

.period-text {
	font-size: 14px;
	color: #9ca3af;
}

/* 区块标题样式 */
.section-wrapper {
	margin-bottom: 24px;
}

.section-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 16px;
	padding-bottom: 10px;
	position: relative;
}

.section-header::after {
	content: '';
	position: absolute;
	bottom: 0;
	left: 0;
	width: 50px;
	height: 3px;
	background: linear-gradient(90deg, #409eff, #93c5fd);
	border-radius: 3px;
}

.section-title {
	font-size: 18px;
	font-weight: 700;
	color: #1f2937;
	display: flex;
	align-items: center;
	margin: 0;
}

.section-title::before {
	content: '';
	display: inline-block;
	width: 5px;
	height: 18px;
	background-color: #409eff;
	margin-right: 8px;
	border-radius: 3px;
}

.section-actions {
	display: flex;
	align-items: center;
}

.view-all-link {
	margin-left: 16px;
}

.create-report-btn {
	font-weight: 600;
	display: flex;
	align-items: center;
}

.create-report-btn i {
	margin-right: 8px;
}

/* 报告卡片样式 */
.report-card {
	background-color: white;
	border-radius: 16px;
	border: 1px solid #f1f5f9;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
	padding: 24px;
	margin-bottom: 20px;
	transition: all 0.3s;
	position: relative;
	overflow: hidden;
	height: 100%;
	display: flex;
	flex-direction: column;
}

.report-card::before {
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	width: 4px;
	height: 100%;
	background-color: #409eff;
	transition: all 0.3s;
	border-radius: 2px;
}

.report-card.draft::before {
	background-color: #e6a23c;
}

.report-card.completed::before {
	background-color: #67c23a;
}

.report-card.review::before {
	background-color: #909399;
}

.report-card:hover {
	box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
	transform: translateX(5px);
}

.report-header {
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	margin-bottom: 12px;
}

.report-title {
	font-size: 16px;
	font-weight: 600;
	color: #1f2937;
	margin: 0;
	transition: all 0.3s;
	flex: 1;
	margin-right: 8px;
}

.report-card:hover .report-title {
	color: #409eff;
}

.report-desc {
	font-size: 14px;
	color: #6b7280;
	margin-bottom: 12px;
	flex: 1;
	display: -webkit-box;
	line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
}

.report-footer {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-top: auto;
}

.report-date {
	font-size: 12px;
	color: #9ca3af;
}

.report-date i {
	margin-right: 4px;
}

.report-actions {
	display: flex;
}

.report-actions .el-button {
	margin-left: 8px;
}

/* 图表容器样式 */
.chart-container {
	background-color: white;
	border-radius: 16px;
	border: 1px solid #f1f5f9;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
	padding: 24px;
	margin-bottom: 20px;
	transition: all 0.3s;
}

.chart-container:hover {
	box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.chart-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 16px;
}

.chart-title {
	font-size: 16px;
	font-weight: 600;
	color: #1f2937;
	margin: 0;
}

.chart-wrapper {
	position: relative;
	height: 300px;
}

.chart-legend {
	position: absolute;
	top: 10px;
	right: 10px;
	display: flex;
	gap: 16px;
	background-color: rgba(255, 255, 255, 0.8);
	padding: 6px 10px;
	border-radius: 6px;
}

.legend-item {
	display: flex;
	align-items: center;
}

.legend-dot {
	width: 10px;
	height: 10px;
	border-radius: 50%;
	margin-right: 6px;
}

.legend-dot.completed {
	background-color: #10b981;
}

.legend-dot.in-progress {
	background-color: #3b82f6;
}

.legend-text {
	font-size: 12px;
	color: #4b5563;
}

/* 活动容器样式 */
.activity-container {
	background-color: white;
	border-radius: 16px;
	border: 1px solid #f1f5f9;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
	padding: 24px;
	margin-bottom: 20px;
	transition: all 0.3s;
	height: 100%;
}

.activity-container:hover {
	box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.activity-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 16px;
}

.activity-title {
	font-size: 16px;
	font-weight: 600;
	color: #1f2937;
	margin: 0;
}

.activity-list {
	display: flex;
	flex-direction: column;
	gap: 16px;
}

.activity-item {
	display: flex;
	align-items: flex-start;
	padding: 12px 0;
	border-bottom: 1px solid #f1f5f9;
}

.activity-item:last-child {
	border-bottom: none;
}

.activity-icon {
	width: 36px;
	height: 36px;
	border-radius: 10px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: 12px;
	transition: all 0.3s;
}

.activity-container:hover .activity-icon {
	transform: scale(1.1);
}

.activity-content {
	flex: 1;
}

.activity-text {
	font-size: 14px;
	color: #4b5563;
	margin: 0 0 4px 0;
}

.activity-time {
	font-size: 12px;
	color: #9ca3af;
	margin: 0;
}

.highlight-text {
	color: #409eff;
}

/* 悬浮创建按钮样式 */
.create-report-fab {
	position: fixed;
	bottom: 40px;
	right: 40px;
	width: 56px;
	height: 56px;
	border-radius: 28px;
	background: #3b82f6;
	box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
	color: white;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: all 0.3s ease;
	cursor: pointer;
	overflow: hidden;
}

.create-report-fab::before {
	content: '';
	position: absolute;
	width: 100%;
	height: 100%;
	background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 100%);
	top: -100%;
	left: -100%;
	transition: all 0.6s;
}

.create-report-fab:hover::before {
	top: 0;
	left: 0;
}

.create-report-fab:hover {
	background: #2563eb;
	width: 160px;
}

.create-report-fab:hover::after {
	content: attr(data-text);
	margin-left: 10px;
	font-weight: 600;
	animation: fadeIn;
}

/* 图表控件样式优化 */
.chart-controls .el-radio-button__inner {
	padding: 8px 16px;
	border-radius: 8px;
	transition: all 0.3s ease;
}
</style>
